import { useQuery } from '@tanstack/react-query';
import type { IMoodBoardDetail } from 'api/resources/moodBoards';
import { getMoodBoard } from 'api/resources/moodBoards';
import { ECacheKeys } from 'cache/CacheKeys';

export const useGetMoodBoard = (token: string, id?: string) => {
	return useQuery<IMoodBoardDetail>({
		queryKey: [ECacheKeys.MoodBoard, id],
		queryFn: () => getMoodBoard(token, id as string),
		// The id comes from the route param, so hold the request back until the
		// router has resolved one.
		enabled: Boolean(id),
		retry: 1,
		refetchOnWindowFocus: false,
	});
};
